/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypeDict } from '@Types/index';
import { Option } from '@Components/types/options';
import { Organization } from '@Types/api/common/dictionary';
import {
  accountModuleOptions,
  moduleOptions,
} from '@Features/EmployeeSelfService/requests/ITRequisition/fieldsOptions';
import { FormikProps } from 'formik';

export const getLabel = (
  key: string,
  value: any,
  attendanceTypes: TypeDict[],
  companies: Option[],
  workLocations: TypeDict[],
  overseasSponsors: TypeDict[],
  accessories: TypeDict[],
  itReqTypes: TypeDict[],
  organizations: Organization[],
  departments: Array<{ key: number; value: string }>,
  projects: Array<{ key: number; value: string }>,
  formik?: FormikProps<any>
): string | null => {
  if (key === 'attendanceType') {
    const label = attendanceTypes.find(
      (item) => item.codeNum === Number(value)
    )?.codeDesc;
    return label || null;
  }

  if (key === 'company') {
    const label = companies.find((item) => item.value === String(value))?.label;
    return label || null;
  }

  if (key === 'location') {
    const label = workLocations.find(
      (item) => item.codeNum === value
    )?.codeDesc;
    return label || null;
  }

  if (key === 'sponsoredBy') {
    const label = overseasSponsors.find(
      (item) => item.codeNum === Number(value)
    )?.codeDesc;
    return label || null;
  }

  if (key === 'accessory') {
    const label = accessories.find(
      (item) => item.codeNum === Number(value)
    )?.codeDesc;
    return label || null;
  }

  if (key === 'itemType') {
    const label = itReqTypes.find((item) => item.codeNum === value)?.codeDesc;
    return label || null;
  }

  if (key === 'module') {
    const label = moduleOptions.find((item) => item.value === value)?.label;
    return label || null;
  }

  if (key === 'accountsModule') {
    const label = accountModuleOptions.find(
      (item) => item.value === value
    )?.label;
    return label || null;
  }

  if (key === 'organization') {
    const label = organizations.find(
      (item) => item.borgId === Number(value)
    )?.borgName;
    return label || null;
  }

  // Contact page specific labels
  if (key === 'workLocation') {
    // Map work location values to proper labels
    if (value === '1') {
      return 'Head Office';
    }
    if (value === '2') {
      return 'Projects';
    }
    return null;
  }

  // Handle department/project mapping using departmentType
  if (key === 'department' && formik?.values?.departmentType) {
    if (formik.values.departmentType === 'department') {
      const department = departments.find(
        (dept) => dept.key.toString() === value
      );
      return department?.value || null;
    }
    if (formik.values.departmentType === 'project') {
      const project = projects.find((proj) => proj.key.toString() === value);
      return project?.value || null;
    }
  }

  // For contact fields that don't need special mapping, return null to use the raw value
  if (
    ['employeeNumber', 'employeeName', 'occupation', 'extension'].includes(key)
  ) {
    return null;
  }

  return null;
};
